export default __webpack_public_path__ + "locales/hy-AM/PDFFormDialog.json?hash=ca2129755e6e5b1bbf726c8b6acee21c";